import React from 'react'
import './Backdrop.scss'

const Backdrop = ({close}:any) => {
    return (
        <div
            className="backdrop"
            onClick={close}
        />
    )
};

export default Backdrop;
